import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Skeleton } from 'antd';

import API from 'src/apis';

import MascotIcon from 'src/assets/images/mascot.png';
import BackgroundImg from 'src/assets/images/bg.png';
import LogoIcon from 'src/assets/images/apex_ai_rotate.svg';
import TatvaCareLogo from 'src/assets/images/tatvacare_logo.png';
import ZydusLogo from 'src/assets/images/zydus_logo.svg';

import styles from './index.module.scss';

const WelcomePage: React.FunctionComponent = () => {
    const navigate = useNavigate();
    const [logoLoading, setLogoLoading] = useState(true);

    const logoSrc = useMemo(() => {
        const userDetails = localStorage.getItem('userDetails');
        const fromVendor = localStorage.getItem('from_vendor');
        return fromVendor && userDetails
            ? JSON.parse(userDetails)?.service_payer_logo || ZydusLogo
            : TatvaCareLogo;
    }, [localStorage.getItem('userDetails')]);

    const appType = useMemo(() => {
        const app = localStorage.getItem('app');
        return app;
    }, [localStorage.getItem('app')]);

    const onPressStart = async () => {
        try {
            await API.UpdateVisitedFlag({ 'welcome_visited': true });
        } catch (error) {
            console.log("error", error);
        } finally {
            navigate('/');
        }
    };

    return (
        <div className={styles.welcomePage}>
            <img src={BackgroundImg} alt='background' style={{ width: '100%' }} />

            <div className={styles.titleContainer}>
                <img src={LogoIcon} alt="Tatva AI logo" />
                <div className={styles.heading}>Welcome to {`${appType === 'zymedelite' ? 'ZyMedAI' : appType === 'ask_tatva' ? 'Ask Tatva' : 'Tatva AI'}`}</div>
                {appType !== 'zymedelite' && <div className={styles.poweredBy}>
                    Powered by
                    <div style={{ height: '19px', width: 'auto' }}>
                        {logoLoading && <Skeleton.Input size='small' active />}
                        <img
                            src={logoSrc}
                            alt={'tatva_logo'}
                            height="19px"
                            style={{ display: logoLoading ? 'none' : 'block' }}
                            onLoad={() => setLogoLoading(false)}
                            onError={(e: any) => { e.target.src = TatvaCareLogo; }}
                        />
                    </div>
                </div>}
            </div>

            <div className={styles.contentContainer}>
                <div className={styles.imageWrapper}>
                    <div className={styles.mascotContainer}>
                        <img src={MascotIcon} alt='mascot' />
                    </div>
                </div>

                <div className={styles.descriptionContainer}>
                    <div className={styles.title}>
                        Apex AI Is Your Personal AI Medical Research Assistant
                    </div>
                    <div className={styles.description}>
                        Converse naturally to get accurate answers to your medical queries from <span className={styles.boldText}>PubMed's</span> extensive <span className={styles.boldText}>research database</span>
                    </div>
                    <div className={styles.continueButton} onClick={onPressStart}>
                        Get Started
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WelcomePage;